/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NoPermissionsParser = /* #__PURE__ */ parsers.object([
    ['hasPerms', /* #__PURE__ */ parsers.exactly(false), 'has_perms'],
]);
export class NoPermissions extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NoPermissionsParser.decode(input).map(res => new NoPermissions(res));
    }
    static unsafeDecode(input) {
        return NoPermissions.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NoPermissionsParser.encode(data);
    }
    static schema() {
        return NoPermissionsParser.schema();
    }
}
